/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */
define([], function () {
	// Temporary array of dashboard feature specs. This can be used to quickly test a dashboard feature without adding to the perspective collection
	// Example:
	// {
	// 	'containerId': 'com.ibm.bi.dashboard.features',
	// 	'name': 'MyFeature',
	// 	'id': 'com.ibm.bi.dashboard.features.myFeature',
	// 	'class': 'dashboard-core/js/features/dashboard/myFeature/MyFeature'
	// }
	return [{
		'containerId': 'com.ibm.bi.dashboard.features',
		'name': 'DashboardProperties',
		'id': 'com.ibm.bi.dashboard.core-features.dashboardProperties',
		'class': 'dashboard-core/js/features/dashboard/dashboardProperties/DashboardPropertiesProvider',
		'dependencies':['API','Properties', 'internal']
	},
	{
		'containerId': 'com.ibm.bi.dashboard.features',
		'name': 'Transaction',
		'id': 'com.ibm.bi.dashboard.core-features.transaction',
		'class': 'dashboard-core/js/features/dashboard/transaction/api/impl/Transaction'
	},
	{
		'containerId': 'com.ibm.bi.dashboard.features',
		'name': 'Serviceability',
		'id': 'com.ibm.bi.dashboard.features.serviceability',
		'class': 'dashboard-core/js/features/dashboard/dashboardServiceability/DashboardServiceability',
		'dependencies': ['API','DashboardState']
	},
	{
		'containerId': 'com.ibm.bi.dashboard.features',
		'name': 'Print',
		'id': 'com.ibm.bi.dashboard.core-features.print',
		'class': 'dashboard-core/js/features/dashboard/print/api/impl/Print',
		'dependencies': ['API']
	},
	{
		'containerId': 'com.ibm.bi.dashboard.features',
		'name': 'DashboardPrint',
		'id': 'com.ibm.bi.dashboard.core-features.dashboardPrint',
		'class': 'dashboard-core/js/features/dashboard/dashboardPrint/api/impl/DashboardPrint'
	},
	{
		'containerId': 'com.ibm.bi.dashboard.features',
		'name': 'ContentActions',
		'id': 'com.ibm.bi.dashboard.core-features.contentActions',
		'class': 'dashboard-core/js/features/dashboard/actions/ContentActions',
		'dependencies': ['API', 'DashboardState']
	},
	{
		'containerId': 'com.ibm.bi.dashboard.features',
		'name': 'Notification',
		'id': 'com.ibm.bi.dashboard.features.notification',
		'class': 'dashboard-core/js/features/dashboard/notification/Notification',
		'dependencies': ['API']
	},
	{
		'name': 'BaseContentProvider',
		'id': 'com.ibm.bi.dashboard.features.BaseContentProvider',
		'class': 'dashboard-core/js/features/dashboard/contentProvider/api/impl/BaseContentProvider',
		'dependencies': ['API','ContentFactory']
	},
	{
		'containerId': 'com.ibm.bi.dashboard.features',
		'name': 'PageContentProvider',
		'id': 'com.ibm.bi.dashboard.features.PageContentProvider',
		'class': 'dashboard-core/js/features/dashboard/contentProvider/api/impl/PageContentProvider',
		'dependencies': ['API', 'ContentFactory']
	}];
});